import React from "react";
import faq_bg from "assets/img/Main Images/Home/faq-img3.png";

const AboutFaqs = ({ element_faq = false, title, head, desc }) => {
  return (
    <React.Fragment>
      <section className="faq__area p-relative">
        <div
          className="faq__video"
          style={{ backgroundImage: `url(${faq_bg})` }}
        >
          <div className="faq__video-btn">
            <a
              href="https://play.google.com/store/apps/details?id=com.rionick.ghar360"
              target="_blank"
              rel="noreferrer"
              className="tp-pulse-border popup-video"
              aria-label="Download Ghar360 from Google Play Store"
            >
              <i className="fa-regular fa-download"></i>
            </a>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row justify-content-end">
            <div className="col-xxl-7 col-xl-7 col-lg-7">
              <div className="faq__wrapper-2 faq__gradient-border faq__style-2 tp-accordion pl-160">
                <div className="faq__title-wrapper">
                  <span className="faq__title-pre">
                    {/* {element_faq
                      ? "Minimal Design"
                      : "Get in touch with us to see how"} */}
                      {head}
                  </span>
                  <h3 className="faq__title">
                  {title}
                    {/* {element_faq
                      ? "Accordion with image"
                      : "Provide smart and flexible digital services"} */}
                  </h3>
                </div>
                <div className="accordion" id="faqaccordion">
                  {/* {faq_items.map((item) => (
                    <SingleFaq key={item.id} item={item} />
                  ))} */}
                  {desc}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </React.Fragment>
  );
};

export default AboutFaqs;
